import { clsx } from 'clsx';

type Props = {
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  label?: string;
};

/** Переключатель настройки. Нативный checkbox под капотом — доступен с клавиатуры. */
export function Toggle({ checked, onChange, disabled, label }: Props) {
  return (
    <label
      className={clsx(
        'relative inline-flex shrink-0 cursor-pointer items-center',
        disabled && 'cursor-not-allowed opacity-50',
      )}
    >
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        aria-label={label}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span
        className={clsx(
          'h-6 w-11 rounded-full bg-slate-200 transition-colors',
          'peer-checked:bg-brand-600',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-brand-400 peer-focus-visible:ring-offset-2',
        )}
      />
      <span
        className={clsx(
          'pointer-events-none absolute left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform',
          'peer-checked:translate-x-5',
        )}
      />
    </label>
  );
}
